export default "__VITE_ASSET__Cuk5YWKE__"